// Store
import * as Actions from '../../../store/bulk/void/bulk.void.actions';

export const LaunchVoidModalStep = (state, jobId) => [Actions.launchBulkVoidResultsModal(jobId)];
